'use client';

import Link from 'next/link';

import { MYPAGE_ROUTER } from '~/constants/router';

import { ShoppingCartLink } from '../../components/ShoppingCartLink';

import SearchIcon from '~/assets/icons/gnb/ic_magnifier_line_24x24.svg';
import MypageIcon from '~/assets/icons/gnb/ic_user_line_24x24.svg';

type Props = {
  SearchLink?: React.ReactNode;
};

export function RightMenu({ SearchLink }: Props) {
  return (
    <div className="ml-8 flex items-center gap-2 text-transparent">
      {SearchLink ? (
        <span className="flex items-center p-6">{SearchLink}</span>
      ) : (
        <Link href="/search">
          <div className="size-[36px] p-6">
            <SearchIcon />
          </div>
        </Link>
      )}
      <ShoppingCartLink />
      <Link href={MYPAGE_ROUTER.root}>
        <div className="size-[36px] p-6">
          <MypageIcon />
        </div>
      </Link>
    </div>
  );
}
